"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const iterateDateRange_1 = __importDefault(require("../../../BusinessLogicLayer/iterateDateRange"));
const TrainingInterface_1 = require("../../../BusinessLogicLayer/TrainingInterface");
class Recovery {
    constructor(tokenService, recoveryRepository, dateTimeModifier, dateTimeProvider) {
        this.getDateRange = async (customerId, dateRange) => {
            // check if user is authenticated
            await this.tokenService.getValidToken();
            const days = [];
            const dates = [];
            (0, iterateDateRange_1.default)(dateRange, this.dateTimeModifier, this.dateTimeProvider, (date) => dates.push(date));
            for (let d = 0; d < dates.length; d++) {
                let day;
                try {
                    day = await this.recoveryRepository.getDay(customerId, dates[d]);
                }
                catch (e) {
                    day = {
                        date: dates[d],
                        dayType: TrainingInterface_1.WeekDayType.TRAINING_DAY,
                        recovery: {
                            heartBeat: null,
                            sleepHours: null,
                            sleepHoursRange: null,
                            sleepQuality: null,
                            muscleStrain: null,
                            stressLevel: null,
                        },
                        progress: {
                            motivation: { value: 1, reason: "" },
                            training: {
                                status: null,
                                reason: null,
                            },
                            lesson: {
                                status: null,
                                reason: null,
                            },
                            water: {
                                status: null,
                                reason: null,
                            },
                            supplements: {
                                status: null,
                                reason: null,
                            },
                            nutrition: {
                                status: null,
                                reason: null,
                            },
                        },
                    };
                }
                days.push(day);
            }
            return {
                days,
                disabledChecklistItems: [],
            };
        };
        this.tokenService = tokenService;
        this.recoveryRepository = recoveryRepository;
        this.dateTimeModifier = dateTimeModifier;
        this.dateTimeProvider = dateTimeProvider;
    }
}
exports.default = Recovery;
//# sourceMappingURL=Recovery.js.map